var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "61",
        height: "61",
        viewBox: "0 0 61 61",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("circle", {
        attrs: {
          cx: "30.5",
          cy: "30.5",
          r: "30.5",
          fill: "white",
          "fill-opacity": "0.25",
        },
      }),
      _c("g", { attrs: { filter: "url(#filter0_d_939_49316)" } }, [
        _c("circle", {
          attrs: {
            cx: "30.5",
            cy: "30.5",
            r: "23.5",
            fill: "url(#paint0_linear_939_49316)",
            stroke: "black",
            "stroke-width": "2",
          },
        }),
        _c("circle", {
          attrs: {
            cx: "30.4999",
            cy: "30.4999",
            r: "19.9286",
            fill: "#62D43F",
          },
        }),
      ]),
      _c(
        "defs",
        [
          _c(
            "filter",
            {
              attrs: {
                id: "filter0_d_939_49316",
                x: "6",
                y: "6",
                width: "49",
                height: "51",
                filterUnits: "userSpaceOnUse",
                "color-interpolation-filters": "sRGB",
              },
            },
            [
              _c("feFlood", {
                attrs: { "flood-opacity": "0", result: "BackgroundImageFix" },
              }),
              _c("feColorMatrix", {
                attrs: {
                  in: "SourceAlpha",
                  type: "matrix",
                  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                  result: "hardAlpha",
                },
              }),
              _c("feOffset", { attrs: { dy: "2" } }),
              _c("feComposite", {
                attrs: { in2: "hardAlpha", operator: "out" },
              }),
              _c("feColorMatrix", {
                attrs: {
                  type: "matrix",
                  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0",
                },
              }),
              _c("feBlend", {
                attrs: {
                  mode: "normal",
                  in2: "BackgroundImageFix",
                  result: "effect1_dropShadow_939_49316",
                },
              }),
              _c("feBlend", {
                attrs: {
                  mode: "normal",
                  in: "SourceGraphic",
                  in2: "effect1_dropShadow_939_49316",
                  result: "shape",
                },
              }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint0_linear_939_49316",
                x1: "30.5",
                y1: "8",
                x2: "30.5",
                y2: "53",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#B5F3A2" } }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#397826" } }),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }